import { render, staticRenderFns } from "./baptis.vue?vue&type=template&id=58d5c91e&scoped=true&"
import script from "./baptis.vue?vue&type=script&lang=js&"
export * from "./baptis.vue?vue&type=script&lang=js&"
import style0 from "./baptis.vue?vue&type=style&index=0&id=58d5c91e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d5c91e",
  null
  
)

export default component.exports